import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { AfterViewInit, Component, Input, OnInit, ViewChild } from '@angular/core';
import { any } from 'codelyzer/util/function';
import { DxDataGridComponent } from 'devextreme-angular';
import CustomStore from 'devextreme/data/custom_store';
import DataSource from 'devextreme/data/data_source';
import dxDataGrid from 'devextreme/ui/data_grid';
import { environment } from '../../../environments/environment';
import { Apiservice } from '../../services/api.service';
import { ComponentService } from '../../services/component.service';
import { NicaAnagraficaComponent } from '../nica-anagrafica/nica-anagrafica.component';
import { alert } from "devextreme/ui/dialog"
import { confirm } from 'devextreme/ui/dialog';
import notify from 'devextreme/ui/notify';
let myThis;any;

@Component({
  selector: 'app-automezzo',
  templateUrl: './automezzo.component.html',
  styleUrls: ['./automezzo.component.css']
})
export class AutomezzoComponent implements OnInit ,AfterViewInit {
  @ViewChild('uAutomezzi', { static: true }) uAutomezzi: NicaAnagraficaComponent; 
 // @ViewChild('gridAuth', { static: true }) gridAuth: DxDataGridComponent; 
  @ViewChild(DxDataGridComponent, { static: false }) gridAuth: DxDataGridComponent;
  //@ViewChild('gridContainerCer', { static: true }) gridContainerCer: DxDataGridComponent; 
  @ViewChild(DxDataGridComponent, { static: false }) gridContainerCer: DxDataGridComponent;
  
  @Input() itemData:any
  myApiCategoriaAlboGestore=environment.BASE_API_URL+'CategoriaAlboGestore';
  myApiCarrozzerieAlboGestore=environment.BASE_API_URL+'CarrozzeriaAlboGestore';
  myApiAutorizzazionePerAutomezzo=environment.BASE_API_URL+'AutomezzoCer';

  CategoriaAlboGestore: any;
  CarrozzerieAlboGestore:any;
  AutorizzazionePerAutomezzo:any; // contiene l'elenco dei cer per tipo  categoria albo + carrozzeria albo

  CustomCer:any;
  
  CurrentAutomezzo:any={};
  isAutomezzoSelected:boolean=false;

  elencoXXXX=[];

  elencoCategoriaAlboGestore;
  idCategoriaAlboGestore:[];

  elencoCarrozzerieAlboGestore;
  idCarrozzerieAlboGestore:[];

  elencoAutorizzazionePerAutomezzo;
  idAutorizzazionePerAutomezzoSelected:[];

  dataElencoGlobaleCer:any;
  ElencoGlobaleCer;

  idCategoriaSelected='000';
  idCarrozzeriaSelected='0000';
  idAutomezzoSelected=0;
  idSedeSelected=0;
  currentAuth: any;
  myFilterStr:string="/0";
  ListaCerAbilitati=[];
  ArrCopiaCer=[];
  idTabRif: any;
  
  constructor(private userComponentService:ComponentService,private appService:Apiservice,private http:HttpClient) {
    
      myThis=this;

   
   }

  
   
  ngAfterViewInit(): void {
    console.log("itemData ",this.itemData);
   
    this.CategoriaAlboGestore = new CustomStore({
        key: 'id',
        load: () => this.http.get(this.myApiCategoriaAlboGestore).toPromise().then(res => {          
          this.elencoCategoriaAlboGestore=res; 
          console.log("Ecco le Categie ",this.elencoCategoriaAlboGestore);    
          return res;
            }
          ),
      });
    

 this.CarrozzerieAlboGestore = new CustomStore({
        key: 'id',
        loadMode:"raw",
        load: () => this.http.get(this.myApiCarrozzerieAlboGestore).toPromise().then(res => {
          this.elencoCarrozzerieAlboGestore=res;
          console.log("Ecco le Crrozzerie ",res);  
          //this.elencoCategoriaAlboGestore=res;
          return res;
            }
          ),
      });

    this.http.get(environment.BASE_API_URL+'Cer').toPromise().then(res => {          
      this.ElencoGlobaleCer=res;
      console.log("ecco i cer ",this.ElencoGlobaleCer);
        }
      )

    




    return;
    this.uAutomezzi.filter="/"+this.idTabRif;
    this.idSedeSelected=this.idTabRif;
    this.uAutomezzi.refresh();
  }

  public inizializza(idSede:any):void{
    // alert(this.idTabRif);
     //this.uAutisti.filter="/"+this.idTabRif;
     if(idSede>0){
      this.idTabRif = idSede
      this.idSedeSelected= this.idTabRif;
       this.uAutomezzi.filter="/"+ this.idTabRif;
     }
     this.uAutomezzi.refresh();
     
   }

   DammiDescrizioneCategoria(id:string){   
    
    console.log()
    //this.elencoCategoriaAlboGestore.filter(s => s.id == id);
    let xxxx =  this.elencoCategoriaAlboGestore.find(t=>t.id ===id);
   console.log("Dopo il find ",xxxx)
    //if(xxxx != undefined)
        //return xxxx['descrizione'];
   }

  ngOnInit() {
    
    if(this.itemData[0]['idTabRif'] ){ // riferimo id unita locale
      
      this.myFilterStr = "/"+this.itemData[0]['idTabRif'];
      this.idTabRif=this.itemData[0]['idTabRif'];
    } 
    
    this.AutorizzazionePerAutomezzo = new DataSource({
      store:new CustomStore({
        key: 'id',
        onLoaded: function (result) {
          console.log("Ho letto ",result);
      },
        load: () => this.http.get(this.myApiAutorizzazionePerAutomezzo+'/'+this.CurrentAutomezzo['id']).toPromise().then(res => {                    
          this.elencoAutorizzazionePerAutomezzo=res['items'];
          console.log("Ecco quello che ho letto ",this.elencoAutorizzazionePerAutomezzo);
            return res['items'];      
          }),
      }),            
    });


    

  }
  onRowInsertedAutorizzazione(e:any){
    //alert('onRowInsertedAutorizzazione ','onRowInsertedAutorizzazione ');
    //console.log('onRowInsertedAutorizzazione',e);
  }
  onRowInsertingAutorizzazione(e:any){
    //alert('onRowInsertingAutorizzazione ','onRowInsertingAutorizzazione ');
    //console.log('onRowInsertingAutorizzazione',e);
  }
  DopoInseritoAutorizzazione(e:any){
    //alert('Dopo Inserito Autorizzazione ','Dopo Inserito Autorizzazione ');
  }
  onSavingAutorizzazione(e:any){
    //alert('OnSaving ','OnSaving ');
    //e.cancel=true;
    let keyCheck=-1;

    if(e.changes[0].type=='update'){
      //alert(e.changes[0].key,"update")
      keyCheck=e.changes[0].key;
      //e.changes[0].data: {…}
    }
  //      elencoAutorizzazionePerAutomezzo
    for(var r=0;r<this.elencoAutorizzazionePerAutomezzo.length;r++){
      if(keyCheck==-1 || this.elencoAutorizzazionePerAutomezzo.id==keyCheck) continue;
      
    }
    

    console.log(e);
/*
changes: Array(1)
0: {data: {…}, key: 1, type: 'update'}
 
*/
  }
  onRowRemovedAuth(e:any){
    //alert("on removed auth","");
    this.ListaCerAbilitati=[];
  }
  onRowRemovedCer(e:any){
    //alert("on removing","on removing");
    this.DopoInseritoCer(e,1);
  }

  onSavingCer(e:any){
    //alert("Saved");
    //console.log("On Saved ",e );
    if(!e.changes) return;
    let actualCer=e.changes[0]['data']['id'];
    let ciccio=e.component.getRowIndexByKey(actualCer);
    console.log("ciccio ",ciccio);
    if(ciccio>-1){
      alert("Cer gia presente","Inserimento CER");
      e.cancel=true;
    }
    e.promise=this.http.get(environment.BASE_API_URL+'Cer/'+e.changes[0]['data']['id']).toPromise().then(res => {

          console.log("ecco il cer letto",res);
          e.changes[0]['data']['descrizione']=res['descrizione'];
          
        }).catch((err: HttpErrorResponse) => {
          // simple logging, but you can do a lot more, see below
          //alert("Cer Non Trovato");
          e.cancel=true
        });
   // e.cancel=true;
  }

  

  DopoInseritoCer(e:any,flag:any){
    let quellechevedo=""
    e.component.getDataSource().store().load({      
  }).then(
      (obj) => {
        quellechevedo=obj;
        let quellechescrivo=[];
        
        for(var r=0;r<quellechevedo.length;r++){
          quellechescrivo.push(quellechevedo[r]['id'])
        }
        this.currentAuth['listaCER']=quellechescrivo;
        var headers = new HttpHeaders();
        console.log("Quelle che vedo ",quellechescrivo);
        headers.append('Content-Type', 'text');     
        const body={id: this.currentAuth.id, listaCER:quellechescrivo};
        return this.http.put(environment.BASE_API_URL+'AutomezzoCer/'+this.currentAuth.id, body,{headers})
        .toPromise()
        .then(response=>{
          this.currentAuth['listaCER']=quellechescrivo;
          response}) 
        .catch();
      }
  );
    setTimeout(() => {
      if(flag==1) return;
      e.component.addRow();
    }, 200);
   
  }
  PrimaDiInserireCer(e:any){
    
    e.cancel=false;
    return; 
    
    console.log("Prima di inserire ",e );
    e.promise=this.http.get(environment.BASE_API_URL+'Cer/'+e['data']['id']).toPromise().then(res => {                
      console.log("ecco il cer letto",res);
        }).catch((err: HttpErrorResponse) => {
          // simple logging, but you can do a lot more, see below
         
          e.cancel=true
        });
  }
  CarrozzerieClick(e:any){
        
    this.idCarrozzeriaSelected=e.addedItems[0]['id']
    this.LeggiCer(null);
  }

  AutorizzazionePerAutomezzoSelect(e:any){
    //alert("Ho selezionato una autorizzazione")
  }

  CategorieClick(e:any){
    
       this.idCategoriaSelected=e.addedItems[0]['id']
       this.LeggiCer(null);
  }

  

  LeggiCer(e:any){
   // console.log("ho selezionato ",e);
    this.currentAuth=e.data;
   // let mes="Sede="+this.idSedeSelected+" idAutomezzo"+this.idAutomezzoSelected+ " IdAutorizzazione="+this.idCategoriaSelected+" idCarrozzeria="+this.idCarrozzeriaSelected;
  //listaCER
  this.ListaCerAbilitati=[];
  this.ListaCerAbilitati.length = 0;
  
  this.currentAuth.listaCER.forEach(element => {      
        this.http.get(environment.BASE_API_URL+'cer/'+element).toPromise().then(res=>{
          let comodDes=element;
          if(res['pericolo']) comodDes+="*";
          let comodoc={'id':comodDes,'descrizione':res['descrizione']};
          this.ListaCerAbilitati.push(comodoc);
          
      })
    });    
    console.log(this.ListaCerAbilitati);

    //alert(mes);

  }
  preparaToolbarAuth(e){
    //---------------------------
    e.toolbarOptions.items.push({
   
      location: "before",
      widget: 'dxTextBox',
      cssClass:"pippa", 
      
      options: {
          text:"Autorizzazioni", 
          readOnly:true                    
      }
    
    });
    
  }
  preparaToolbarCer(e){
    const that = this;
    //---------------------------
e.toolbarOptions.items.push({
   
  location: "before",
  widget: 'dxTextBox',
  cssClass:"pippa", 
  
  options: {
      text:"Elenco CER", 
      readOnly:true ,
      width:"100px",                   
  }

});
e.toolbarOptions.items.push({
  location: "before",
  widget: 'dxButton',
  cssClass:"pippa", 
  options: {
      icon: "fa fa-copy",
      //text:bottone.options.text,                     
      elementAttr:{title:"Copia CER"},                  
      onClick:function(e: any){ 
        if(that.ListaCerAbilitati.length==0) return;
        that.ArrCopiaCer=that.ListaCerAbilitati;//that.currentAuth['listaCER']; 
        notify("Cer Copiati",'info');
        
        
        
      }
  }
});
e.toolbarOptions.items.push({
  location: "before",
  widget: 'dxButton',
  cssClass:"pippa", 
  
  options: {
      icon: "fa fa-paste",
      
      //text:bottone.options.text,                     
      elementAttr:{title:"Incolla CER"},                  
      onClick: ()=>{ 
        if(this.ArrCopiaCer.length==0) return;
        //alert("clikkato su incolla");
        let result = confirm("<i>ATTENZIONE! La funzione sostituisce eventuale EER già presenti. Pocedere?</i>", "");
        result.then((dialogResult) => {
            if(dialogResult){
              this.ListaCerAbilitati=[];
              this.ListaCerAbilitati.length = 0;        
              this.ListaCerAbilitati=that.ArrCopiaCer;
              //--------------------------------------------------------------------------------------------     
              let quellechescrivo=[];
              for(var r=0;r<this.ListaCerAbilitati.length;r++){
                quellechescrivo.push(this.ListaCerAbilitati[r]['id'])
              }
              this.currentAuth['listaCER']=quellechescrivo;
              var headers = new HttpHeaders();
              headers.append('Content-Type', 'text');     
              const body={id: this.currentAuth.id, listaCER:quellechescrivo};
              return this.http.put(environment.BASE_API_URL+'AutomezzoCer/'+this.currentAuth.id, body,{headers})
              .toPromise()
              .then(response=>{
              this.currentAuth['listaCER']=quellechescrivo;
              }) 
              .catch();            
              //--------------------------------------------------------------------------------------------      
            }           
        });



        //that.currentAuth['listaCER']
       // let result=this.pulsantiOpzionali.indexOf(bottone);
       // if(bottone.options.index !=undefined) result= bottone.options.index
       // this.optionalBottoneToolbar.emit(result);//this.pulsantiOpzionali.indexOf(bottone)
      }
  }
});

e.toolbarOptions.items.push({
  location: "after",
  widget: 'dxButton',
  cssClass:"btDanger", 
  options: {
      icon: "fa fa-trash",
      //text:bottone.options.text,
      color:"red",
      elementAttr:{title:"Elimina Tutti i CER"},                  
      onClick:function(e: any){that.EliminaTuttiCer(e)}
  }
});

//xxx
}
  optionalButtonAutomezzoAutorizzazioni(e:any){
    console.log("in click ",e)
   // this.gridContainer.refresh();
   
    this.CurrentAutomezzo=e.row.data;
    this.isAutomezzoSelected=true;
    
    this.idAutomezzoSelected=this.CurrentAutomezzo['id'];
    this.ListaCerAbilitati=[];
    //this.grid.instance.clearSelection;
    this.elencoXXXX=[];
    this.AutorizzazionePerAutomezzo = new DataSource({
      store:new CustomStore({
        key: 'id',
        onLoaded: function (result) {
          console.log("Ho letto ",result);
      },
        load: () => this.http.get(this.myApiAutorizzazionePerAutomezzo+'/'+this.CurrentAutomezzo['id']).toPromise().then(res => {          
          console.log("Ecco quello che ho letto ",res);
            //
            return res['items'];      
          }),

          insert: (values) => {
            values['idAutomezzo']=this.idAutomezzoSelected;
            //alert('Inserttttttttttt '+this.idAutomezzoSelected);
           // values[this.asDetail.chiave]=this.detailValue;

          return this.http.post(this.myApiAutorizzazionePerAutomezzo  , values)
            .toPromise()
            .then(res=>{console.log(res), console.log(values)})
            .catch()

            ;
        }
        ,
        update: (key, values) => {
          return this.http.put(this.myApiAutorizzazionePerAutomezzo+ '/'+ encodeURIComponent(key)  , values)
            .toPromise()
            .then(res=>{console.log(res), console.log(values)});
        }
        ,
        remove: (key) => {
          return this.http.delete(this.myApiAutorizzazionePerAutomezzo+ '/'+ encodeURIComponent(key)  )
            .toPromise().then();
        }          
          


          
        }),            
    });

   // this.LeggiCer(null);

    //console.log("Automezzo select",e)
    //alert("wwwwww4 "+this.isAutomezzoSelected,"");
  }
  onEditingStart(e:any){
    this.isAutomezzoSelected=false;
    //alert("wwwwww2","");
  }
  onAutomezzoSelected(e:any){
    //alert("wwwwww3","");
    this.isAutomezzoSelected=false;
    //this.CurrentAutomezzo=e;
    //this.isAutomezzoSelected=true;
    //console.log("Automezzo select",e)
  }
  //
  EliminaTuttiCer= (e: any) => {
    if(this.ListaCerAbilitati.length==0) return;
    let result = confirm("<i>ATTENZIONE1 La funzione eleimina i cer presenti. Pocedere?</i>", "");
    result.then((dialogResult) => {
        if(dialogResult){
          this.ListaCerAbilitati=[];
          this.ListaCerAbilitati.length = 0; 
          //--------------------------------------------------------------------------------------------
        let quellechescrivo=[];        
        this.currentAuth['listaCER']=quellechescrivo;
        var headers = new HttpHeaders();
        console.log("Quelle che vedo ",quellechescrivo);
        headers.append('Content-Type', 'text');     
        const body={id: this.currentAuth.id, listaCER:quellechescrivo};
        return this.http.put(environment.BASE_API_URL+'AutomezzoCer/'+this.currentAuth.id, body,{headers})
        .toPromise()
        .then(response=>{
            this.currentAuth['listaCER']=quellechescrivo;
            }) 
        .catch(); 
  //--------------------------------------------------------------------------------------------
        }           
    });

  }
  CopiaCer= (e: any) => {
    return;
    if(!this.currentAuth){
    
      return;
    }
    console.log(this.currentAuth);
    console.log(e);
    console.log(myThis);
    myThis.gridAuth.instance.getDataSource().store().load({      
    }).then(
        (obj) => {
          console.log("Ecco i cer in griglia ",obj);
        })
  }
  onClickHandler(e:any){
    //alert("wwwwwwwwwww","wwwwwwwwwww");
  }
  onAllEventAutomezzo(e:any){

    if (e.name == ('onCellPrepared')) {
      this.isAutomezzoSelected=false;
      if (e.columnIndex == 0) {
        
        
        //e.column.visible=false;
        if (e.data && e.data.isSospeso ==true) {         
          let link=$(e.cellElement).find(".dx-link").css("color","orange");
        } else {
        let link=$(e.cellElement).find(".dx-link").css("color","#7ab8eb");
        }
      }      
    }







    console.log(e);
    //onEditorPrepared
    if(e.name==('onEditorPrepared')){
      //alert("wwwwww1","");
      this.isAutomezzoSelected=false;
    }
    
    if(e.name==('onSaving')){
      if(e.changes.length)
          e.changes[0]['data']['idSede']=this.idTabRif;
    }
  }
}
